import Particles from "@tsparticles/vue3"
import { loadFireworksPreset } from "@tsparticles/preset-fireworks"
import { loadConfettiPreset  } from "@tsparticles/preset-confetti"

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(Particles, {
    init: async engine => {
      await loadConfettiPreset(engine)
      await loadFireworksPreset(engine)
    },
  })
})
